import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionStatusService } from '../services/sessionStatus.service';

/*
  SessionStatusInterceptor is responsible to polling the remaining time
  of user inactivity on every request. In each request it'll call
  getStatusTimeout in sessionStatusService
*/

@Injectable({
  providedIn: 'root'
})
export class SessionStatusInterceptor implements HttpInterceptor {
  constructor(private sessionStatusService: SessionStatusService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.sessionStatusService.getStatusTimeout();

    return next.handle(req);
  }
}
